import { Paper, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import VerifiedIcon from '@mui/icons-material/Verified';
import { useQuery } from 'react-query';
// import { useParams } from 'react-router-dom';
import { getOrderByNumber } from '../../api/apis';
import { currencyFormatter } from '../../lib/helpers/currency.helper';
import { IEntityContentField } from '../../lib/interfaces/Common';
import { IOrder } from '../../lib/interfaces/Order';
import Loader from '../Simple/Loader/Loader';
import { ProductStatus } from './payment.consts';
import './PaymentPage.scss';

type ServicePaymentPageProps = {
	orderNumber: number;
};

const ServicePaymentPage: FC<ServicePaymentPageProps> = ({ orderNumber }) => {
	// const { orderNumber = '' } = useParams();
	const { t, i18n } = useTranslation();
	const [orderRetries, setOrderRetries] = useState<number>(0);
	const currentLanguage: string = i18n.language;
	const [isRetryLoading, setIsRetryLoading] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);

	const refetchAfterTimeout = (refetchFn: () => void) => {
		setIsRetryLoading(true);
		setOrderRetries(orderRetries + 1);
		setTimeout(refetchFn, 1500);
	};

	const { data, isLoading, refetch } = useQuery<IOrder, Error>(
		['product', orderNumber],
		() => getOrderByNumber(Number(orderNumber)),
		{
			onSuccess(order: IOrder) {
				if (order.status === ProductStatus.PENDING && orderRetries < 5) {
					refetchAfterTimeout(refetch);
				} else if (order.status === ProductStatus.PAID) {
					setIsRetryLoading(false);
				} else {
					setIsRetryLoading(false);
				}
			},
			onError: () => {
				setError(true);
			},
		},
	);

	const contentFields: IEntityContentField[] = data?.product
		? data.product.content[currentLanguage]
		: [];
	const productName = contentFields?.find((field) => field.label === 'Name');

	// const openCalendly = () => {
	// 	if (data?.orderDetails.meetingLink) {
	// 		window.open(data?.orderDetails.meetingLink, '_blank');
	// 	}
	// };

	if (error) {
		return (
			<div style={{ paddingTop: '80px', maxWidth: 1100, margin: '0 auto' }}>
				{t('noOrderFound')}
			</div>
		);
	}

	return !isLoading && !isRetryLoading && data ? (
		<div
			className="PaymentPage"
			style={{ paddingTop: '80px', maxWidth: 1100, margin: '0 auto' }}
		>
			<div style={{ display: 'flex' }}>
				<div>
					<VerifiedIcon className="success-icon" style={{ fontSize: 60 }} />
				</div>
				<div style={{ marginLeft: '20px' }}>
					<Typography variant="h4" component="h4">
						{t('thankYou')}
					</Typography>
					<Typography variant="body1" component="div">
						{t('thankYouOrder')}
					</Typography>
				</div>
			</div>
			<div style={{ display: 'flex', paddingTop: '10px' }}>
				<Paper
					style={{ padding: '30px', marginRight: '30px' }}
					variant="outlined"
					elevation={0}
				>
					<div>
						<Typography variant="h5" component="h5">
							{t('theOrder')} #{data.orderNumber}
						</Typography>
					</div>

					<hr style={{ margin: '20px 0' }} />
					<Typography variant="h6" component="h5">
						{productName?.content}
					</Typography>
					<Typography variant="h6" component="div">
						{currencyFormatter(data.unitPrice)}
					</Typography>

					{data.status !== 'confirmed' &&
					data.status !== 'delivered' &&
					data.status !== 'refunded_canceled' &&
					data.status !== 'refunded_delivered' ? (
						<div>
							{/* <Typography
								variant="body1"
								component="div"
								style={{ paddingTop: '20px' }}
							>
								{t('thankYouLinkInstructions')}:
							</Typography>
							<Button
								variant="contained"
								disableElevation
								style={{ marginTop: '10px' }}
								onClick={openCalendly}
							>
								{t('chooseTimeSlot')}
							</Button>
							<Typography
								variant="body1"
								component="div"
								style={{ paddingTop: '20px' }}
							>
								{t('afterSchedulingMeetingInfo')}.
							</Typography> */}
							<Typography
								variant="body1"
								component="div"
								style={{ paddingTop: '20px' }}
							>
								{t('emailDuplcatedThankyou')}.
							</Typography>
							<Typography
								variant="body1"
								component="div"
								style={{ paddingTop: '20px' }}
							>
								{t('lookingForwardToConnecting')}.
							</Typography>
						</div>
					) : null}
				</Paper>
				<div style={{ marginRight: '20px', maxWidth: '400px' }}>
					<img src={data.product.imageUrl} alt="" style={{ width: '100%' }} />
				</div>
			</div>
		</div>
	) : (
		<Loader />
	);
};

export default ServicePaymentPage;
